import { render } from "./dataEmpty.vue?vue&type=template&id=2897aeb6&scoped=true"
import script from "./dataEmpty.vue?vue&type=script&lang=js"
export * from "./dataEmpty.vue?vue&type=script&lang=js"

import "./dataEmpty.vue?vue&type=style&index=0&id=2897aeb6&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2897aeb6"]])

export default __exports__